import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { useEffect, useMemo, useState } from "react";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPost, sendPut } from "api/restUtil";
import Float from "components/input/Float";
import ReactDataTableModifiable from "components/DataTable/ReactDataTableModifiable";
import DatePickerInput from "components/input/DatePickerInput";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import { modConfirm, saveConfirm } from "js/common";

/**
 * 지점 휴일 등록/수정 팝업
 */
function BranchHolidayMgmtModal (props) {

	const { isOpen, onClose, initData, modalId, title } = props;
	const [ data, setData ] = useState({})
	const [ mode, setMode ] = useState("add");


	useEffect(() => {
		if(initData == null || !isOpen) return;
		setData(initData);

		if(initData.hasOwnProperty("holiday") && initData.holiday != null && initData.holiday !== '') {
			setMode("mod");
		} else {
			setMode("add");
		}
	}, [initData, isOpen]);


	// data 변경시
	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};

		let val = value;
		// boolean은 text가 아닌 형태로 형변환
		if(value === "true") val = true;
		else if(value === "false") val = false;

		if(e.target.tagName.toLowerCase() === "input" && e.target.type.toLowerCase() === "checkbox") {
			// 체크박스는 선택 여부에 따라서 다르게 처리됨.
			val = Array.from(document.querySelectorAll("#branchAddModModal input[type='checkbox'][name=" + e.target.name + "]:checked")).map(obj => obj.value);
		}

		if(name.includes(".")) {
			let nmArr = name.split(".");
			let obj = d;
			for(let i=0; i<nmArr.length; i++) {
				const key = nmArr[i];

				if(i == nmArr.length - 1) {
					obj[key] = val;
				} else {
					if(!obj.hasOwnProperty(key)) {
						obj[key] = {};
					}
					obj = obj[key];
				}
			}

		} else {
			d[name] = val;
		}

		setData(d);
	}

	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#branchHolidayMgmtModal");
	}, [data]);

	// 저장
	const onClickOk = async() => {
		
		const requiredColumns = ["holiday", "type", "activationYn"];
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, "#branchHolidayMgmtModal")) return;

		if(mode === "add") {
			if(!saveConfirm()) return;

			const result = await sendPost("/api/mgmt/branch/" + data.branchId + "/holiday", data);
			if(result.respCode === "SUCCESS") {
				alert("저장되었습니다.");
				onClose && onClose();
			}
		} else if(mode === "mod") {
			if(!modConfirm()) return;
			
			const result = await sendPut("/api/mgmt/branch/" + data.branchId + "/holiday/" + data.holiday + "/" + data.type, data);
			if(result.respCode === "SUCCESS") {
				alert("저장되었습니다.");
				onClose && onClose();
			}

		}
	}
	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">

				<div className="me-modal-container" style={{width: "600px", height: "500px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="branchHolidayMgmtModal">
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>지점 ID</th>
											<td>
												{data.branchId}
											</td>
										</tr>
										<tr>
											<th>지점 명</th>
											<td>
												{initData?.branchName}
											</td>
										</tr>
										{mode == "add" && (
											<tr>
												<th>날짜<span className="burgundy">*</span></th>
												<td>
													<DatePickerInput
														name="holiday"
														autoComplete="off"
														value={data?.holiday ?? ""}
														onChange={(e) => handleDataChange(e)}
														style={{width: "150px"}}
													/>
												</td>
											</tr>
										)}
										{mode == "mod" && (
											<tr>
												<th>날짜</th>
												<td>
													{data.holiday}
												</td>
											</tr>
										)}
										<tr>
											<th>휴일 유형<span className="burgundy">*</span></th>
											<td>
												<div style={{width: "150px"}}>
													<CommonCodeSelect item={{col: "type"}} onChange={handleDataChange} value={data?.["type"] || ""} grpCd={"HOLIDAY_TYPE"} />
												</div>
											</td>
										</tr>
										<tr>
											<th>활성화 여부<span className="burgundy">*</span></th>
											<td>
												<select name={"activationYn"} className="basic-input" style={{width: "150px"}} onChange={handleDataChange} value={data?.activationYn}>
													<option value="">선택하세요.</option>
													<option value={true}>활성</option>
													<option value={false}>비활성</option>
												</select>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								<BasicButton label="저장" className="btn-save" onClick={onClickOk} style={{width: "100%"}} />

							</div>
						</div>

					</div>

				</div>
			</div>

		</ReactModal>
	);
}

export default BranchHolidayMgmtModal;
